<template>
  <Select
      :closeOnSelect="false"
      :deselectFromDropdown="false"
      :get-option-key="option => option"
      :get-option-label="option => option?.text"
      :multiple="true"
      :reduce="option => option"
      :value="dropdownValue"
      v-bind="$attrs"
      v-on="$listeners"
      @option:selected="onSelected"
  />
</template>

<script>
export default {
  name: "MultiSelect",
  props: {
    value: [Number, String, Array, Object],
    options: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    multiple: true,
    newOptions: [],
  }),
  watch: {
    options: {
      handler(newVal) {
        if (!newVal.length) return;
        this.newOptions = newVal;
      },
      immediate: true
    },
  },
  computed: {
    dropdownValue: {
      get() {
        return this.newOptions.length ? this.newOptions.filter(x => this.value.includes(x.id)) : [];
      },
      set(newDropdownValue) {
        if (newDropdownValue === null) {
          newDropdownValue = [];
        }
        this.$emit("input", newDropdownValue);
        const obj = this.paginated.filter(x => x.id === newDropdownValue);
        this.$emit("change", obj || newDropdownValue);
      }
    },
  },
  methods: {
    onSelected(otps) {
      // this.$emit("update:options", otps)
      this.newOptions = otps;
    },
  }
}
</script>
